import { render, staticRenderFns } from "./CreateNewOrder.vue?vue&type=template&id=0e7895d2&scoped=true"
import script from "./CreateNewOrder.vue?vue&type=script&lang=js"
export * from "./CreateNewOrder.vue?vue&type=script&lang=js"
import style0 from "./CreateNewOrder.vue?vue&type=style&index=0&id=0e7895d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7895d2",
  null
  
)

export default component.exports